import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

import "./styles.scss";

import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupText,
    Button
} from "reactstrap";
import FollowUs from "../../components/FollowUs/FollowUs";
import IconPlus from "../../components/Icons/IconPlus";
import Countries from 'country-json/src/country-by-name.json';
import CountriesAbb from 'country-json/src/country-by-abbreviation.json';
import CountriesPhoneCodes from 'country-json/src/country-by-calling-code.json';

const Contact = () => {
    const [errors, setErrors] = useState({});
    const [programQry, setProgramQry] = useState("");

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const program = params.get("program");

        if (program) {
            setProgramQry(program);
        }

    }, [location]);

    const countriesCodes = CountriesPhoneCodes.map(phoneCodeEntry => {
        const countryName = phoneCodeEntry.country;
        const phoneCode = phoneCodeEntry.calling_code;

        const countryAbbEntry = CountriesAbb.find(country => country.country === countryName);
        if (countryAbbEntry) {
            return {
                abbreviation: countryAbbEntry.abbreviation,
                phoneCode: phoneCode
            };
        }
        return null;
    }).filter(entry => entry !== null);

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();
            const form = document.querySelector(".form");
            const formData = new FormData(form);
            const data = {};
            const newErrors = {};

            formData.forEach((value, key) => {
                data[key] = value;
                if (!value) {
                    newErrors[key] = true;
                }
            });

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            await axios.post("https://www.thefmimadrid.com/api/form.php", data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .finally(() => window.location.href = "/gracias");
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <Container fluid tag="main" className="contact py-5">
                <Row tag="section">
                    <Col className="text-center">
                        <h1 className="title">Formulario de Inscripción</h1>
                    </Col>
                </Row>
                <Container>
                    <Row tag="section" className="pt-5">
                        <Form onSubmit={handleFormSubmit} className="form">
                            <Row tag="article">
                                <FormGroup className="col-12 col-lg-10 col-xl-8">
                                    <div>
                                        <Label for="master">Programa en el que estás interesado</Label>
                                        <Input type="select" name="master" id="master" invalid={errors.master}>
                                            {!programQry && <option disabled selected></option>}
                                            <option value="Master Dirección Deportiva" selected={programQry === 'Master-Direccion-Deportiva'}>
                                                Master Dirección Deportiva
                                            </option>
                                            <option value="Marketing y Comunicación digital" selected={programQry === 'Marketing-Comunicacion-digital'}>
                                                Marketing y Comunicación digital
                                            </option>
                                            <option value="Finanzas y Gestión Deportiva" selected={programQry === 'Finanzas-Gestion-Deportiva'}>
                                                Finanzas y Gestión Deportiva
                                            </option>
                                        </Input>
                                    </div>
                                </FormGroup>
                            </Row>
                            <Row tag="article">
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="name">Nombre</Label>
                                        <Input type="text" name="name" id="name" invalid={errors.name} />
                                    </div>
                                </FormGroup>
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="lastName">Apellido</Label>
                                        <Input type="text" name="lastName" id="lastName" invalid={errors.lastName} />
                                    </div>
                                </FormGroup>
                            </Row>
                            <Row tag="article">
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="country">País de residencia</Label>
                                        <Input type="select" name="country" id="country" invalid={errors.country}>
                                            <option disabled selected></option>
                                            {Countries.map((item, i) => <option key={i} value={item.country}>{item.country}</option>)}
                                        </Input>
                                    </div>
                                </FormGroup>
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="name">Mail</Label>
                                        <InputGroup tag="span">
                                            <Input type="text" name="mail" id="mail" invalid={errors.mail} />
                                            <InputGroupText>
                                                @
                                            </InputGroupText>
                                            <Input type="text" name="mailProvider" id="mailProvider" placeholder="gmail.com" invalid={errors.mailProvider} />
                                        </InputGroup>
                                    </div>
                                </FormGroup>
                            </Row>
                            <Row tag="article">
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="bornDate">Fecha de nacimiento</Label>
                                        <Input type="date" name="bornDate" id="bornDate" invalid={errors.bornDate} />
                                    </div>
                                </FormGroup>
                                <FormGroup className="col-12 col-lg-6">
                                    <div>
                                        <Label for="phone">Celular</Label>
                                        <span className="input-phone d-flex">
                                            <Input type="select" name="phoneCode" id="phoneCode" invalid={errors.phoneCode}>
                                                <option disabled selected></option>
                                                {
                                                    countriesCodes.map((phone, i) =>
                                                        <option key={i} value={`+${phone.phoneCode}`}>({phone.abbreviation}) +{phone.phoneCode}</option>
                                                    )
                                                }
                                            </Input>
                                            <Input type="number" name="phone" id="phone" invalid={errors.phone} />
                                        </span>
                                    </div>
                                </FormGroup>
                            </Row>
                            <Row tag="article">
                                <FormGroup className="col-12 col-lg-6 footballer">
                                    <Label for="phone">¿Sos o fuiste futbolista?</Label>
                                    <Input type="radio" value="Si" name="footballer" invalid={errors.footballer} className="me-2" />
                                    <Input type="radio" value="No" name="footballer" invalid={errors.footballer} />
                                </FormGroup>
                            </Row>
                            <Row tag="article">
                                <FormGroup className="justify-content-center button-container">
                                    <Button tag="button" className="btn__cta">
                                        <IconPlus width={66} height={66} />
                                        <span>Enviar</span>
                                    </Button>
                                </FormGroup>
                            </Row>
                        </Form>
                    </Row>
                </Container>
            </Container>
            <FollowUs />
        </>
    );
};

export default Contact;